transformedParams